import type {
  DetachedDeviceViewEntities,
  DeviceViewEntities,
  DeviceViewEntity,
  DeviceViewEntityId,
} from 'components/DeviceView/deviceViewTypes';

export const getActiveDeviceViewEntityId = (
  currentActiveDeviceViewEntityId: DeviceViewEntityId | null,
  deviceViewEntities: DeviceViewEntities,
  detachedDeviceViewEntities: DetachedDeviceViewEntities,
): DeviceViewEntityId | null =>
  (currentActiveDeviceViewEntityId ||
    deviceViewEntities.filter(
      (deviceViewEntity: DeviceViewEntity) =>
        !detachedDeviceViewEntities.includes(deviceViewEntity.id),
    )[0]?.id) ??
  null;
